import { useIonModal, useIonToast } from '@ionic/react';
import { FullPost, calcDateSpanDescription } from 'model';
import { useState } from 'react';
import { useReportPostMutation, useUnReportPostMutation } from '../api/ReportApi';
import { ReportValuesType, UIReportReasons } from '../model/report';
import { Confirmation } from '../pages/Confirmation';
import { IconButton } from './IconButton';
// eslint-disable-next-line css-modules/no-unused-class
import sharedstyles from '../styles/Shared.module.css';
import { Select } from './Forms/Select';
import { PostContentsToHTML } from './PostContentsToHTML';
import { ProfilePic } from './ProfilePic';
import { IconReport, IconReportSolid } from './QuirkIcons';
import { TruncatedSummary } from './TruncatedSummary';

interface reportPostType {
	post: FullPost;
	hideTooltip?: () => void;
	isReported: boolean;
	disabled?: boolean;
}

export const ReportPost: React.FC<reportPostType> = ({ post, hideTooltip, isReported, disabled }) => {
	const [unReportPost] = useUnReportPostMutation();
	const [presentReported] = useIonToast();
	const [reportPost] = useReportPostMutation();
	const [reportValues, setReportValues] = useState<ReportValuesType>({ document: post._id, reason: 'offensive' });
	const handleReportPost = async () => {
		dismiss();
		hideTooltip && hideTooltip();
		if (post) {
			if (isReported) {
				presentReported({
					color: 'success',
					message: 'Post has been un-reported',
					position: 'top',
					duration: 1500
				});
				await unReportPost(reportValues);
			} else {
				presentReported({
					color: 'danger',
					message: 'Post has been reported',
					position: 'top',
					duration: 1500
				});
				await reportPost(reportValues);
			}
		}
		hideTooltip && hideTooltip();
	};

	const engage = async () => {
		!isReported ? present() : handleReportPost();
	};

	const [present, dismiss] = useIonModal(Confirmation, {
		onDismiss: () => dismiss(),
		action: handleReportPost,
		cancelAction: hideTooltip,
		actionLabel: 'Report',
		dismissLabel: 'Cancel',
		content: (
			<>
				<div className={sharedstyles.userContainer}>
					<ProfilePic user={post.fullAuthor} />
					<div className="fullwidth">
						<div className={sharedstyles.name}>{post.fullAuthor.username}</div>
						<div className={sharedstyles.time}>{calcDateSpanDescription(post?.fullAuthor.updated)}</div>
					</div>
				</div>
				<h5>Are you sure you want to report this post?</h5>
				<div className="space10" />
				<Select
					id="reason"
					placeholder="Select Reason"
					label="Select Reason"
					value={reportValues.reason}
					name="reason"
					options={UIReportReasons}
					onChange={e => {
						setReportValues({
							...reportValues,
							reason: e.detail.value
						});
					}}
				/>
				<div className="space20" />
				<TruncatedSummary>
					<PostContentsToHTML>{post.contents}</PostContentsToHTML>
				</TruncatedSummary>
			</>
		)
	});

	let reportLabel = isReported ? 'Unreport' : 'Report';
	if (disabled) reportLabel = '...';

	return (
		<IconButton
			testId="ReportPostButton"
			disabled={disabled}
			label={reportLabel}
			icon={isReported ? <IconReportSolid /> : <IconReport />}
			onClick={engage}
		/>
	);
};
